var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../node_modules/source-map-loader/dist/cjs.js!./index.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
var ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___ = ___EXPOSE_LOADER_IMPORT___.backendless
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["backendless"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["backendless"] = ___EXPOSE_LOADER_IMPORT_MODULE_LOCAL_NAME___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
